import React, { useState } from "react";
import { Link } from "react-router-dom";
import Carousel from "../../components/Carousel/Carousel";
import { getFacilityData } from "../../components/Facilities/FacilityData";
import Navigation from "../../components/Footer/Navigation";
import FacilitySection from "../../components/Facilities/FacilitySection";
import NavigationModal from "../../components/Modals/NavigationModal";
import Footer from "../../components/Footer/Footer";
import { data } from "../../components/Carousel/Carousel";
import PromotionBanner from "../../components/Promotion/PromotionBanner";
import { t } from "@lingui/macro";
import "./Home.css";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // TO JEST KLUCZOWE:
  // Dane z tłumaczeniami pobieramy dopiero tutaj,
  // kiedy Lingui ma już aktywne locale
  const facilityData = getFacilityData();

  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>Balneario El Arenal</h1>
        <h2>{t`Live the Arenal experience!`}</h2>

        <div className="carousel">
          <Carousel images={data} />
        </div>

        <Link to="/buy-tickets">
          <button className="buy-tickets-button">
            {t`Buy Tickets`}
          </button>
        </Link>
      </div>

      <PromotionBanner />

      <section className="facilities-section">
        {facilityData.map((info, index) => (
          <FacilitySection
            key={index}
            image={info.image}
            title={info.title}
            description={info.description}
            buttonText={info.buttonText}
            link={info.link}
            reverse={info.reverse}
            isModal={info.isModal}
            modalContent={info.modalContent}
          />
        ))}
      </section>

      <NavigationModal isOpen={isModalOpen} onClose={closeModal}>
        <Navigation />
      </NavigationModal>

      <Footer showModal={showModal} closeModal={closeModal} />
    </div>
  );
};

export default Home;
